<template>
  <div class="fzxw">
    <div class="banner">
      <img class=" banner_img" src="../../static/img/chanpin_banner.png" alt="">
    </div>
    <div class="content">
      <div class="xq w1200">
        <div class="rb" v-for="(item,i) in fzImg" :key="i" v-if="$route.query.id - 0 === i">
          <img :src="item.img1" alt="">
          <ul class="sm">
            <li>
              <img :src="item.img2" alt="">
              <p>公众号关注</p>
            </li>
            <li>
              <img :src="item.img3" alt="">
              <p>二维码下载</p>
            </li>
            <li class="ckrz">
              <img :src="item.img4" alt="">
              <p>查看软著</p>
              <img class="rzxq" :src="item.img5" alt="">
            </li>
          </ul>
          <img class="rbb" :src="item.img6" alt="">
          <img :src="item.img7" alt="">
          <img @click="skip('http://icid.iachina.cn/?columnid_url=201509301401')" :src="item.img8" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fzxw',
  data () {
    return {
      fzImg: [
         {
          img1: require('../../static/img/fz_rb_tb.png'),
          img2: require('../../static/img/rebao.jpg'),
          img3: require('../../static/img/热保.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/rb_rz.png'),
          img6: require('../../static/img/fz_rb_what.png'),
          img7: require('../../static/img/fz_rb_ys.png'),
          img8: require('../../static/img/fz_rb_tz.png'),
          id: '0'
        },
        {
          img1: require('../../static/img/fz_lhb_tb.png'),
          img2: require('../../static/img/lianhebao.jpg'),
          img3: require('../../static/img/联合保.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/lhb_rz.png'),
          img6: require('../../static/img/fz_lhb_what.png'),
          img7: require('../../static/img/fz_lhb_ys.png'),
          img8: require('../../static/img/fz_lhb_tz.png'),
          id: '1'
        },
          {
          img1: require('../../static/img/fz_xe_tb.png'),
          img2: require('../../static/img/xiaoerbaoxian.jpg'),
          img3: require('../../static/img/小二保险.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/xe_rz.png'),
          img6: require('../../static/img/fz_xe_what.png'),
          img7: require('../../static/img/fz_xe_ys.png'),
          img8: require('../../static/img/fz_xe_tz.png'),
          id: '2'
        },
         {
          img1: require('../../static/img/fz_zzb_tb.png'),
          img2: require('../../static/img/zizunbao.jpg'),
          img3: require('../../static/img/紫尊保.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/zzb_rz.png'),
          img6: require('../../static/img/fz_zzb_what.png'),
          img7: require('../../static/img/fz_zzb_ys.png'),
          img8: require('../../static/img/fz_zzb_tz.png'),
          id: '3'
        },
        {
          img1: require('../../static/img/fz_lcb_tb.png'),
          img2: require('../../static/img/lichebao.jpg'),
          img3: require('../../static/img/利车保.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/lcb_rz.png'),
          img6: require('../../static/img/fz_lcb_what.png'),
          img7: require('../../static/img/fz_lcb_ys.png'),
          img8: require('../../static/img/fz_lcb_tz.png'),
          id: '4'
        },
        {
          img1: require('../../static/img/fz_thb_tb.png'),
          img2: require('../../static/img/taihuibao.jpg'),
          img3: require('../../static/img/太慧宝.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/tb_rz.png'),
          img6: require('../../static/img/fz_thb_what.png'),
          img7: require('../../static/img/fz_thb_ys.png'),
          img8: require('../../static/img/fz_thb_tz.png'),
          id: '5'
        },
        {
          img1: require('../../static/img/fz_dlb_tb.png'),
          img2: require('../../static/img/dinglongbao.jpg'),
          img3: require('../../static/img/鼎龙宝.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/dlb_rz.png'),
          img6: require('../../static/img/fz_dlb_what.png'),
          img7: require('../../static/img/fz_dlb_ys.png'),
          img8: require('../../static/img/fz_dlb_tz.png'),
          id: '6'
        },
         {
          img1: require('../../static/img/fz_xbb_tb.png'),
          img2: require('../../static/img/xiebaobao.jpg'),
          img3: require('../../static/img/协保宝.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/xbb_rz.png'),
          img6: require('../../static/img/fz_xbb_what.png'),
          img7: require('../../static/img/fz_xbb_ys.png'),
          img8: require('../../static/img/fz_xbb_tz.png'),
          id: '7'
        },
        {
          img1: require('../../static/img/fz_fz_tb.png'),
          img2: require('../../static/img/feizhubaoxian.jpg'),
          img3: require('../../static/img/飞猪保险.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/fz_rz.png'),
          img6: require('../../static/img/fz_fz_what.png'),
          img7: require('../../static/img/fz_fz_ys.png'),
          img8: require('../../static/img/fz_fz_tz.png'),
          id: '8'
        }  
      ]
    }
  },
   mounted() {
      let id = this.$route.query.id
      if(this.isMobile()) {

            this.$router.push({path:'/fzproducts?id=', query: {id:id}})
            } else {
            this.$router.push({path:'/cpfz?page=3&id=', query: {id: id}})
            }
  },
  methods: {
    skip (url) {
      location.href = url
    },
     isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
    max-width: 19.2rem;
    width: 100%;
    margin: 0 auto;
    // font-size: 24px;
    min-height: 34.88rem;
    height: auto;
    position: relative;
    background-color: #ffffff;
    .xq {
        width: 12.03rem;
        text-align: center;
        left: 50%;
        margin: 0 auto;
        position: absolute;
        transform: translateX(-50%) translateY(-2.5rem);
        margin: 0 auto;
        background-color: #fff;
        img {
            display: block;
            margin: 0 auto;
        }
        .rb {
            position: relative;
            .sm {
                width: 6rem;
                height: 1.9rem;
                display: flex;
                position: absolute;
                top: 4rem;
                //  box-sizing: border-box;
                padding: 0 .3rem;
                li {
                    width: 1.38rem;
                    // height: 190px;
                    margin: 0 .2rem;
                    p {
                        font-size: .26rem;
                        font-weight: 700;
                        color: #fff5fd;
                        text-align: center;
                        line-height: .6rem;
                    }
                    img {
                        display: block;
                        width: 1.38rem;
                        height: 1.38rem;
                    }
                }
                .rzxq {
                    position: absolute;
                    top: -1rem;
                    left: 3rem;
                    display: none;
                    width: 4.16rem;
                    height: 5.61rem;
                }
                .ckrz:hover .rzxq {
                   display: block;
                    transition: all 1s;
                    // transform: scale(1.2);
                }
            }
            .rbb {
                margin: .6rem auto;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Cpfz.vue